import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { PoliticasCredito } from '../../_models/politicas-credito';
import { PoliticasCreditoOficina } from '../../_models/politicas-credito-oficina';
import { PoliticasCreditoOficinaService } from '../../_services/politicas-credito-oficina.service';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { EstructuraFisica } from '../../_models/estructura-fisica';

@Component( {
  selector: 'app-politicas-credito-oficinas',
  templateUrl: 'politicas-credito-oficinas.component.html'
} )

export class PoliticasCreditoOficinasComponent implements OnInit {

  @Input() politica: PoliticasCredito;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  lisOficinas: SelectItem[] = [];
  lisOficinasTodos: EstructuraFisica[] = [];
  carInformacionInicial = true;
  lisPoliticasOficinas: PoliticasCreditoOficina[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];

  constructor(
    private conServicio: ConfirmationService,
    private politicaCreditoOficinaService: PoliticasCreditoOficinaService,
    private estructuraFisicaService: EstructuraFisicaService,
    private nav: NavService,
    private fb: FormBuilder ) {

  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'nombreOficina', header: this.nav.buscarMensaje( 'POLITICAS.LBL_OFICINA' ), sort: true },
      { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];


    forkJoin(
      this.politicaCreditoOficinaService.obtenerPorIdPoliticaCredito( this.politica.idPoliticaCredito ),
      this.estructuraFisicaService.getAllEnabled()
    ).subscribe( ( [ politicaOficinas, oficinas ] ) => {
      this.lisPoliticasOficinas = politicaOficinas.filter( x => x.indicadorHabilitado );
      this.lisOficinasTodos = oficinas.filter( x => x.indicadorHabilitado );
      this.cargarOficinas();
      this.inicializarFormulario();
      /*if ( this.lisOficinasTodos.length === 0 ) {
        this.nav.setMesage( 4, {
          severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.nav.buscarMensaje( 'CANALES.MSG_NOEXISTEPRODUCTOS' )
        } );
      }*/
      this.carInformacionInicial = false;

    } );


  }

  cargarOficinas() {
    this.lisOficinas = [];
    this.lisOficinasTodos.map( ( oficina: EstructuraFisica ) => {
      if ( !this.lisPoliticasOficinas.find( x => x.idEstructuraFisica === oficina.idEstructuraFisica ) ) {
        this.lisOficinas.push( { label: oficina.estructuraFisica, value: oficina.idEstructuraFisica } );
      }
    } );
  }

  inicializarFormulario() {
    this.formulario = this.fb.group( {
      idOficinas: [ [], [ Validators.required ] ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const ofiCrear = this.formulario.value;
      let ofiAgregar = [];
      if ( ofiCrear.idOficinas ) {
        ofiCrear.idOficinas.map( s => {
          const regAgregar = {} as PoliticasCreditoOficina;
          regAgregar.idPoliticaCredito = this.politica.idPoliticaCredito;
          regAgregar.indicadorHabilitado = true;
          regAgregar.idEstructuraFisica = s;
          ofiAgregar.push( regAgregar );
        } );
      }

      if ( ofiAgregar.length > 0 ) {
        this.politicaCreditoOficinaService.bulk( ofiAgregar ).subscribe( oficinas => {
          oficinas.map( ( s: PoliticasCreditoOficina ) => {
            const a = this.lisOficinasTodos.find( x => x.idEstructuraFisica === s.idEstructuraFisica );
            if ( a ) {
              s.nombreOficina = a.estructuraFisica;
            }
            this.lisPoliticasOficinas = [ ...this.lisPoliticasOficinas, s ];
            // this.lisProductosDestinos.push( s );
          } );
          this.cargarOficinas();
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
          this.nav.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.nav.setMesage( 3 );
        } );
      } else {
        this.nav.setMesage( 1 );
        this.guardando = false;
      }

    }
  }

  inhabilitar( oficina: PoliticasCreditoOficina ) {

    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'oficinas',
      accept: () => {
        this.carInformacionInicial = true;
        oficina.indicadorHabilitado = false;
        this.politicaCreditoOficinaService.actualizar( oficina ).subscribe( regActualizado => {
          const a = this.lisPoliticasOficinas.findIndex( x => x.idPoliticaCreditoOficina === oficina.idPoliticaCreditoOficina );
          if ( a >= 0 ) {
            this.lisPoliticasOficinas.splice( a, 1 );
          }
          this.cargarOficinas();
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );

  }

  irSiguiente() {
    this.dismiss.emit( 'SEGMENTO' );
  }

  get f() {
    return this.formulario.controls;
  }

}
